import { DataBean } from "../DataBean";

export class NationalizationSupport extends DataBean {


    public async getNationalizationSupportCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("ProcessContractERP", "java.util.List_getNationalizationSupportCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }

}